<template>
  <b-modal
    id="modal-punch-data-download"
    :visible="visible"
    title="Download Punch In/Out Data"
    size="sm"
    ok-title="Download CSV"
    cancel-title="Cancel"
    ok-variant="success"
    :ok-disabled="!punchDownloadFrom || !punchDownloadTo"
    @ok="$emit('ok')"
    @hidden="$emit('update:visible', false)"
  >
    <p class="text-muted mb-3" style="font-size: 0.88rem;">
      Select the date range to export punch-in and punch-out records.
    </p>

    <div class="d-flex flex-wrap mb-3" style="gap: 6px;">
      <b-button
        v-for="preset in punchDownloadPresets"
        :key="preset.value"
        size="sm"
        :variant="punchDownloadActivePreset === preset.value ? 'primary' : 'outline-secondary'"
        :class="punchDownloadActivePreset === preset.value ? 'font-weight-bold' : ''"
        @click.stop="$emit('set-range', preset.value)"
      >
        <feather-icon v-if="punchDownloadActivePreset === preset.value" icon="CheckIcon" size="12" class="mr-25" />
        {{ preset.label }}
      </b-button>
    </div>

    <b-form-group label="From" label-class="font-weight-bold small">
      <b-form-input
        :value="punchDownloadFrom"
        type="date"
        size="sm"
        :max="punchDownloadTo || ''"
        @change="$emit('update:punchDownloadFrom', $event); $emit('clear-preset')"
      />
    </b-form-group>

    <b-form-group label="To" label-class="font-weight-bold small" class="mb-0">
      <b-form-input
        :value="punchDownloadTo"
        type="date"
        size="sm"
        :min="punchDownloadFrom || ''"
        @change="$emit('update:punchDownloadTo', $event); $emit('clear-preset')"
      />
    </b-form-group>

    <p
      v-if="punchDownloadFrom && punchDownloadTo"
      class="text-primary mt-2 mb-0"
      style="font-size: 0.82rem;"
    >
      <feather-icon icon="CalendarIcon" size="12" class="mr-1" />
      {{ punchDownloadRangeSummary }}
    </p>
  </b-modal>
</template>

<script>
import {
  BModal, BFormGroup, BFormInput, BButton,
} from 'bootstrap-vue'

export default {
  name: 'PunchDataDownloadModal',
  components: {
    BModal, BFormGroup, BFormInput, BButton,
  },
  props: {
    visible: { type: Boolean, default: false },
    punchDownloadFrom: { type: String, default: '' },
    punchDownloadTo: { type: String, default: '' },
    punchDownloadActivePreset: { type: String, default: null },
    punchDownloadPresets: { type: Array, default: () => [] },
    punchDownloadRangeSummary: { type: String, default: '' },
  },
}
</script>
